/**
 * Built-in outline templates — frontend mirror of the backend `/api/sermons/templates`
 * payload. Used when the dialog opens before the network call resolves so the
 * picker is never empty. Backend is the source of truth; this is a fallback.
 */
export const FALLBACK_TEMPLATES = [
  {
    id: 'default',
    name_en: 'Default 4-point',
    name_es: '4 puntos clásico',
    description_en: 'Introduction · Point 1 · Point 2 · Conclusion',
    description_es: 'Introducción · Punto 1 · Punto 2 · Conclusión',
  },
  {
    id: 'expository_3',
    name_en: '3-Point Expository',
    name_es: 'Expositivo de 3 puntos',
    description_en: 'Hook · Book · Look · Took',
    description_es: 'Gancho · Texto · Mirada · Acción',
  },
  {
    id: 'narrative',
    name_en: 'Narrative Arc',
    name_es: 'Arco Narrativo',
    description_en: 'Setting · Conflict · Climax · Resolution · Application',
    description_es: 'Escenario · Conflicto · Clímax · Resolución · Aplicación',
  },
];

export const ILLUSTRATION_TYPE_LABELS = {
  personal_story: { en: 'Personal Story', es: 'Historia Personal' },
  word_picture: { en: 'Word Picture', es: 'Cuadro Hablado' },
  analogy: { en: 'Analogy', es: 'Analogía' },
  example: { en: 'Example', es: 'Ejemplo' },
  divided_story: { en: 'Divided Story', es: 'Historia Dividida' },
};

export const ILLUSTRATION_TYPES = Object.keys(ILLUSTRATION_TYPE_LABELS);

export const labelForType = (type, language = 'en') =>
  ILLUSTRATION_TYPE_LABELS[type]?.[language] || type;
